import { StoreSchema } from '../../../../shared/config/storeConfig/StoreSchema'

export const selectNewPreset = (store: StoreSchema) => store.newPreset.preset